export default __webpack_public_path__ + "img/bNLCjnJZ.3013bdbd.svg";